module.exports = __webpack_public_path__ + "img/computer-chip2size.8d7b79e8.png";